export default "__VITE_ASSET__BQeNrDy2__"